import { createNS } from "@ontologies/core";

const wdp = createNS("http://www.wikidata.org/prop/");

export default {
  ns: wdp,
};
